export const eraserConfig = {
  aperturePx: 20,
};
